import { get } from 'lodash'
import React, { useContext } from 'react'
import { TextField, TextFieldProps, Typography } from '@mui/material'

import { FormContext } from '../Contexts'
import { FieldError } from 'react-hook-form'

type TextFieldRegisteredProps = Omit<TextFieldProps, 'error'> & { name: string; error?: FieldError }

const TextFieldRegistered: React.FC<TextFieldRegisteredProps> = (props: TextFieldRegisteredProps) => {
  const { register, formState } = useContext(FormContext)
  const error = get(formState?.errors, props.name)

  return (
    <>
      <TextField
        {...props}
        variant={props.variant || 'standard'}
        fullWidth
        {...(register ? register(props.name) : {})}
        error={!!error}
      />
      <Typography variant="inherit" color="red" align="left" style={{ marginTop: 10 }}>
        {error?.message?.toString()}
      </Typography>
    </>
  )
}

export { TextFieldRegistered }
